export default "__VITE_ASSET__f5255df4__"